/**
 * Candidate-rejection send errors.
 *
 * The reject toasts print the backend's error verbatim, which is right for the
 * human strings it usually returns — but a raw code reached a customer's
 * screen in ENG-3828, so the codes we have actually seen get copy here.
 */
export default {
  err_survey_link_required_in_email_body: {
    message:
      'This email includes a survey but no survey link. Add the link to the body, or remove the survey.',
  },
};
